<template>
  <!-- 数字滚动容器 -->
  <div ref="scrollContainer" class="number-scroll-container" :class="className">
    <div class="number-scroll-wrapper" style="display: flex;">
      <!-- 遍历拆分后的数字/字符 -->
      <div v-for="(digit, index) in digitList" :key="index" class="number-scroll-item">
        <!-- 非数字直接展示（如+号） -->
        <span v-if="isNaN(Number(digit))" class="non-number-digit">{{ digit }}</span>
        <!-- 数字执行滚动动画 -->
        <div v-else class="number-digit-wrapper">
          <!-- 👇 只改了这里，把一串文字换成 0-9 每个一行 -->
          <div ref="numberDigit" class="number-digit" :data-digit="digit" :data-index="index">
            0<br>1<br>2<br>3<br>4<br>5<br>6<br>7<br>8<br>9
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    targetNumber: {
      type: [String, Number],
      required: true
    },
    speed: {
      type: Number,
      default: 7
    },
    className: {
      type: String,
      default: ''
    },
    triggerOnce: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      digitList: [],
      observer: null,
      animationTimers: {},
      hasAnimated: false
    }
  },
  watch: {
    targetNumber: {
      immediate: true,
      handler(newVal) {
        this.digitList = String(newVal).split('')
        if (this.hasAnimated && this.triggerOnce) return
        this.hasAnimated = false
        this.initObserver()
      }
    }
  },
  mounted() {
    this.initObserver()
  },
  beforeUnmount() {
    Object.values(this.animationTimers).forEach(timer => {
      if (timer) cancelAnimationFrame(timer)
    })
    this.observer && this.observer.disconnect()
  },
  methods: {
    initObserver() {
      if (!this.$refs.scrollContainer || (this.hasAnimated && this.triggerOnce)) return
      this.observer && this.observer.disconnect()

      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.startScrollAnimation()
            this.triggerOnce && this.observer.disconnect()
          }
        })
      }, {threshold: 0.1})

      this.observer.observe(this.$refs.scrollContainer)
    },

    startScrollAnimation() {
      if (this.hasAnimated) return
      this.hasAnimated = true

      const digitNodes = this.$refs.numberDigit
      const nodes = Array.isArray(digitNodes) ? digitNodes : [digitNodes]

      nodes.forEach(node => {
        const index = node.dataset.index
        const targetDigit = Number(node.dataset.digit)
        let currentOffset = 0
        const targetOffset = targetDigit * 10

        if (this.animationTimers[index]) {
          cancelAnimationFrame(this.animationTimers[index])
        }

        const animate = () => {
          if (currentOffset < targetOffset) {
            currentOffset += 1
            node.style.transform = `translateY(-${currentOffset}%)`
            this.animationTimers[index] = requestAnimationFrame(animate)
          } else {
            cancelAnimationFrame(this.animationTimers[index])
            this.animationTimers[index] = null
          }
        }

        setTimeout(() => {
          this.animationTimers[index] = requestAnimationFrame(animate)
        }, index * this.speed)
      })
    }
  }
}
</script>

<style scoped lang="less">
.number-scroll-container {
  display: inline-block;

  .number-scroll-wrapper {
    display: flex;
  }

  .non-number-digit {
    font-size: 120px;
    line-height: 1;
    margin-left: 9px
  }

  .number-digit-wrapper {
    position: relative;
    overflow: hidden;
    height: 133px;
    font-size: 120px;
    line-height: 1;
  }

  /* 🔥 彻底删除 writing-mode，全平台兼容 */

  .number-digit {
    display: block;
    text-align: center;
    transform: translateY(0%) translateZ(0);
    transition: none;
    will-change: transform;
    backface-visibility: hidden;
    line-height: 1.1;
  }

  .number-scroll-item {
    margin-left: 0;

    &:first-child {
    }

    &:last-child {
      margin-left: 0;
    }
  }

  @media @mobile {
    .number-scroll-item {
      margin-left: 0;

      &:first-child {
        margin-left: 0;
      }
    }

    .number-digit-wrapper {
      height: 64px;
      font-size: 56px;
    }

    .non-number-digit {
      font-size: 56px;
    }
  }
}
</style>